// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k-kintell-card-favoutite-count__text[data-v-75fba50e]{left:17px;position:absolute;top:6px;transform:translateY(-50%)}.v-tooltip__content[data-v-75fba50e]{background-color:grey!important;padding:5px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
